import { type PropsWithChildren } from 'react';

import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import { StoreProvider } from './StoreProvider.js';
import type {
  ColorPalette,
  CustomColorPalette,
} from '../../../core/types/color-palette.js';
import type { Formatter } from '../../../core/types/formatter.js';
import { FormatterContext } from '../../shared/context/FormatterContext.js';
import type { MultiMeterBarSegmentProps } from '../types/multi-meter-bar-chart.js';

interface MultiMeterBarProvidersProps {
  colorPalette: ColorPalette | CustomColorPalette;
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit>;
  segments: MultiMeterBarSegmentProps[];
}

export const MultiMeterBarProviders = ({
  colorPalette,
  formatter,
  segments,
  children,
}: PropsWithChildren<MultiMeterBarProvidersProps>) => {
  return (
    <FormatterContext.Provider value={{ formatter }}>
      <StoreProvider colorPalette={colorPalette} segmentsSlot={segments}>
        {children}
      </StoreProvider>
    </FormatterContext.Provider>
  );
};
